<template>
  <div class="menu-wrapper">
    <template v-if="hasOneShowingChild(item.children, item) && (!onlyOneChild.children || onlyOneChild.noShowingChildren) && !item.alwaysShow">
      <el-menu-item :class="[( isActive(item.path)) ?'active':'' ]" style="text-align: left;" :index="resolvePath(onlyOneChild.path)">
        <!-- <i :class="onlyOneChild.meta.icon"></i> -->
        <span slot="title">{{onlyOneChild.name}}</span>
      </el-menu-item>
    </template>
    <el-submenu style="text-align: left;" v-else :index="resolvePath(item.path)">
      <template slot="title">
        <!-- <i :class="item.meta.icon"></i> -->
        <span slot="title">{{item.name}}</span>
      </template>
      <template v-for="child in item.children">
        <template v-if="child.children && child.children.length>0">
          <sidebar-item :item="child" :key="child.name" :base-path="resolvePath(child.path)" />
        </template>
        <template v-else>
          <el-menu-item :class="[( isActive(child.path)) ?'active':'' ]" style="text-align: left; color: #626262;" :index="resolvePath(child.path)" :key="child.name">
            <!-- <i :class="child.meta.icon"></i> -->
            <span slot="title">{{child.name}}</span>
          </el-menu-item>
        </template>
      </template>
    </el-submenu>
  </div>
</template>

<script>
import path from "path";
import sidebarItem from "./sidebar-item.vue";
function isExternal (path) {
  return /^(https?:|mailto:|tel:)/.test(path)
}
export default {
  name: "SidebarItem",
  components: { sidebarItem },
  props: {
    item: {
      type: Object,
      required: true,
    },
    basePath: {
      type: String,
      default: "",
    },
  },
  data () {
    return {
      onlyOneChild: null,
    };
  },
  computed: {
    isActive () {
      return val => {
        console.log('this.$route.path', this.$route.path, val);

        if (this.$route.path == val) {
          return true
        } else {
          return false
        }
      }
    },
  },
  methods: {
    hasOneShowingChild (children = [], parent) {
      if (children.length === 1) {
        this.onlyOneChild = children[0];
        return true;
      }
      if (children.length === 0) {
        this.onlyOneChild = { ...parent, path: "", noShowingChildren: true };
        return true;
      }
      return false;
    },
    resolvePath (childrenPath) {
      const routePath = childrenPath
      if (this.isExternalLink(routePath)) {
        return routePath;
      }
      return path.resolve(this.basePath, routePath);
    },
    isExternalLink (routePath) {
      return isExternal(routePath);
    },
  },
};
</script>
<style  scoped>
/* ::v-deep .el-menu-item {
  background-color: #fff !important;
  color: #666 !important;
  border-bottom: 1px solid $borderColor;
}
::v-deep .el-submenu__title {
  background-color: #fff !important;
  color: #666 !important;
  border-bottom: 1px solid $borderColor;
} */
.active {
  background: #dde8f3;
  border-left: 2px solid #0072f0;
  margin: 10px 6px;
}
.el-menu-item.is-active {
  color: #409eff !important;
}
</style>



// WEBPACK FOOTER //
// src/components/sidebar-item.vue